var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v("Welcome to elocalculator.com! This is a quick website I built to learn more about VueJS. Hope you find it useful!")]), _vm._v(" "), _c('p', [_vm._v("To find more information about my chess applications, go to "), _c('a', {
    attrs: {
      "href": "https://darksquaregames.com"
    }
  }, [_vm._v("darksquaregames.com")]), _vm._v(" or check out all my iOS apps at "), _c('a', {
    attrs: {
      "href": "https://itunes.apple.com/developer/id878126674"
    }
  }, [_vm._v("https://itunes.apple.com/developer/id878126674")])]), _vm._v(" "), _c('p', [_vm._v("In order to find other great chess resources, visit "), _c('a', {
    attrs: {
      "href": "https://chessfort.com"
    }
  }, [_vm._v("chessfort.com")])]), _vm._v(" "), _c('p', [_vm._v("Elo Calculator is also available at the  iOS App Store")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "inline-block",
      "overflow": "hidden",
      "background": "url(//linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg) no-repeat",
      "width": "135px",
      "height": "40px",
      "background-size": "contain"
    },
    attrs: {
      "href": "https://itunes.apple.com/us/app/elo-calculator-calculate-your-new-chess-rating/id1000600209?mt=8"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37413a1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = N2i+
// module chunks = 1